import { useCallback, useRef } from 'react';

function usePersistFn(fn) {
  var ref = useRef(function () {
    throw new Error('Cannot call function while rendering.');
  });
  ref.current = fn;
  var persistFn = useCallback(function () {
    return ref.current.apply(ref, arguments);
  }, [ref]);
  return persistFn;
}

export default usePersistFn;